import { useMutation, useQueryClient } from "react-query";
import { updateFranchiseUserStatus } from ".";
import { toast } from "../../../components/toastNotification";

export const useUpdateFranchiseUserStatus = () => {
  const queryClient = useQueryClient();
  let status = false;
  const FranchiseUserMutation = useMutation(
    (userStatus) => {
      updateFranchiseUserStatus(
        userStatus.userId,
        userStatus.status,
        userStatus.userType
      );
      status = userStatus.status;
    },
    {
      onSuccess: (res) => {
        if (res) {
          if (res.statusCode === 500 || res.statusCode === 400) {
            toast.fire("Server Error", "Cannot display data", "error");
          }
        } else {
          queryClient.invalidateQueries(["AllUser"]);
          toast.fire(
            "Success",
            "User has been updated successfully.",
            "success"
          );
          localStorage.setItem("isFranchise", status);
        }
      },
    }
  );

  return { FranchiseUserMutation };
};
